function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { unionMemberList, unionMemberDelete, unionMemberCreate, unionMemberUpdate, unionMemberDetail, unionMemberImport, unionMemberExport, unionMemberGetTemplate, unionMemberBatchDelete, unionMemberBatchEnable, unionMemberBatchDisable, unionMemberStatistics } from '@/api/union';
import { fullSync, syncUnionBase, syncUnionUser } from '@/api/unionSync';
import { checkPermi } from '@/utils/permission';
import ButtonUploadExcel from '@/components/ButtonUploadExcel';
export default {
  components: {
    ButtonUploadExcel: ButtonUploadExcel
  },
  data: function data() {
    return {
      constants: this.$constants,
      loading: false,
      filterCollapse: ['1'],
      columnVisible: false,
      importVisible: false,
      unionId: null,
      unionName: null,
      deptId: null,
      query: {
        account: null,
        realName: null,
        sex: null,
        phone: null,
        email: null,
        dateRange: [],
        registerTimeRange: [],
        keyword: null,
        userType: null,
        isActive: null,
        ageRange: null,
        birthBegin: null,
        birthEnd: null,
        year: null,
        holiday: null,
        roleId: null,
        registerTimeBegin: null,
        registerTimeEnd: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      editDialog: {
        visible: false,
        isCreate: true,
        form: {},
        loading: false
      },
      detailDialog: {
        visible: false,
        data: {}
      },
      selectedRows: [],
      statistics: {},
      syncLoading: false,
      editRules: {
        account: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        phone: [{
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        email: [{
          type: 'email',
          message: '请输入正确的邮箱格式',
          trigger: 'blur'
        }]
      },
      columnOptions: {
        id: 'ID',
        avatar: '头像',
        account: '账号',
        name: '昵称',
        real_name: '姓名',
        phone: '手机',
        email: '邮箱',
        sex: '性别',
        created_at: '创建时间'
      },
      selectedColumns: ['avatar', 'account', 'name', 'real_name', 'phone', 'email', 'sex'],
      visibleColumns: {}
    };
  },
  computed: {
    editDialogTitle: function editDialogTitle() {
      return this.editDialog.isCreate ? '新增会员' : '编辑会员';
    }
  },
  mounted: function mounted() {
    this.unionId = Number(this.$route.query.unionId) || null;
    this.unionName = this.$route.query.unionName || '';
    this.deptId = this.$route.query.deptId || null;
    this.initColumnSettings();
    this.fetchStatistics();
    this.fetchList();

    // 添加快捷键支持
    this.addKeyboardShortcuts();
  },
  beforeDestroy: function beforeDestroy() {
    // 移除快捷键监听
    this.removeKeyboardShortcuts();
  },
  methods: {
    checkPermi: checkPermi,
    initColumnSettings: function initColumnSettings() {
      var _this = this;
      this.selectedColumns.forEach(function (col) {
        _this.$set(_this.visibleColumns, col, true);
      });
    },
    saveColumnSettings: function saveColumnSettings() {
      var _this2 = this;
      this.visibleColumns = {};
      this.selectedColumns.forEach(function (col) {
        _this2.$set(_this2.visibleColumns, col, true);
      });
      this.columnVisible = false;
    },
    fetchStatistics: function () {
      var _fetchStatistics = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var id, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              // 使用unionId或deptId进行统计查询
              id = this.unionId || this.deptId;
              _context.n = 1;
              return unionMemberStatistics(id);
            case 1:
              response = _context.v;
              // 根据后端返回的数据结构调整
              if (response && response.data) {
                this.statistics = response.data;
              } else {
                this.statistics = response || {};
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.warn('获取统计数据失败，使用默认数据:', _t);
              // 如果API调用失败，使用默认数据
              this.statistics = {
                totalMembers: 0,
                activeMembers: 0,
                maleMembers: 0,
                femaleMembers: 0,
                totalUsers: 0,
                activeUsers: 0,
                maleUsers: 0,
                femaleUsers: 0
              };
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function fetchStatistics() {
        return _fetchStatistics.apply(this, arguments);
      }
      return fetchStatistics;
    }(),
    formatSex: function formatSex(sex) {
      var map = {
        0: '未知',
        1: '男',
        2: '女',
        3: '保密'
      };
      return map[sex] || '-';
    },
    getSexTagType: function getSexTagType(sex) {
      var map = {
        0: 'info',
        1: 'success',
        2: 'warning',
        3: 'info'
      };
      return map[sex] || 'info';
    },
    fetchList: function fetchList() {
      var _this3 = this;
      this.loading = true;
      var params = _objectSpread({}, this.query);

      // 添加工会ID参数
      if (this.unionId) {
        params.unionId = this.unionId;
      }

      // 添加deptId参数
      if (this.deptId) {
        params.deptId = this.deptId;
      }

      // 处理日期范围
      if (params.dateRange && params.dateRange.length === 2) {
        params.beginDate = params.dateRange[0];
        params.endDate = params.dateRange[1];
      }
      delete params.dateRange;

      // 处理注册时间范围
      if (params.registerTimeRange && params.registerTimeRange.length === 2) {
        params.registerTimeBegin = params.registerTimeRange[0];
        params.registerTimeEnd = params.registerTimeRange[1];
      }
      delete params.registerTimeRange;

      // 清理空值参数
      Object.keys(params).forEach(function (key) {
        if (params[key] === null || params[key] === undefined || params[key] === '') {
          delete params[key];
        }
      });
      console.log('会员列表查询参数:', params);
      console.log('当前unionId:', this.unionId);
      console.log('当前deptId:', this.deptId);
      unionMemberList(params).then(function (res) {
        // 根据后端返回的数据结构调整
        if (res.data && res.data.list) {
          _this3.listData = res.data;
        } else if (res.list) {
          _this3.listData = res;
        } else {
          _this3.listData = res || {
            list: [],
            total: 0
          };
        }
        _this3.loading = false;
      }).catch(function (error) {
        var _error$response, _error$response$data;
        console.error('获取会员列表失败:', error);
        _this3.loading = false;
        _this3.listData = {
          list: [],
          total: 0
        };
        _this3.$message.error('获取会员列表失败: ' + (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || error.message || '未知错误'));
      });
    },
    doSearch: function doSearch() {
      this.query.page = 1;
      this.fetchList();
    },
    resetSearch: function resetSearch() {
      this.query = {
        account: null,
        realName: null,
        sex: null,
        phone: null,
        email: null,
        dateRange: [],
        registerTimeRange: [],
        keyword: null,
        userType: null,
        isActive: null,
        ageRange: null,
        birthBegin: null,
        birthEnd: null,
        year: null,
        holiday: null,
        roleId: null,
        registerTimeBegin: null,
        registerTimeEnd: null,
        page: 1,
        limit: this.constants.page.limit[0]
      };
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.query.limit = val;
      this.fetchList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.page = val;
      this.fetchList();
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleBatchAction: function handleBatchAction(command) {
      var _this4 = this;
      if (!this.selectedRows.length) {
        this.$message.warning('请先选择要操作的数据');
        return;
      }
      var ids = this.selectedRows.map(function (row) {
        return row.id;
      });
      switch (command) {
        case 'batchDelete':
          this.$confirm('确认批量删除选中的会员吗？', '提示', {
            type: 'warning'
          }).then(function () {
            unionMemberBatchDelete(ids).then(function () {
              _this4.$message.success('批量删除成功');
              _this4.fetchList();
              _this4.fetchStatistics();
            }).catch(function () {
              _this4.$message.error('批量删除失败');
            });
          });
          break;
        case 'batchEnable':
          this.$confirm('确认批量启用选中的会员吗？', '提示', {
            type: 'warning'
          }).then(function () {
            unionMemberBatchEnable(ids).then(function () {
              _this4.$message.success('批量启用成功');
              _this4.fetchList();
              _this4.fetchStatistics();
            }).catch(function () {
              _this4.$message.error('批量启用失败');
            });
          });
          break;
        case 'batchDisable':
          this.$confirm('确认批量禁用选中的会员吗？', '提示', {
            type: 'warning'
          }).then(function () {
            unionMemberBatchDisable(ids).then(function () {
              _this4.$message.success('批量禁用成功');
              _this4.fetchList();
              _this4.fetchStatistics();
            }).catch(function () {
              _this4.$message.error('批量禁用失败');
            });
          });
          break;
      }
    },
    handleImportExport: function handleImportExport(command) {
      switch (command) {
        case 'export':
          this.exportList();
          break;
        case 'template':
          this.downloadTemplate();
          break;
        case 'import':
          this.importVisible = true;
          break;
      }
    },
    downloadTemplate: function downloadTemplate() {
      var _this5 = this;
      unionMemberGetTemplate().then(function (response) {
        if (response.data && response.data.fileName) {
          // 直接使用后端返回的文件URL进行下载
          var link = document.createElement('a');
          link.href = response.data.fileName;
          link.download = '会员信息导入模板.xlsx';
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          _this5.$message.success('模板下载成功');
        } else {
          _this5.$message.error('获取模板下载链接失败');
        }
      }).catch(function (error) {
        console.error('下载模板失败:', error);
        _this5.$message.error('下载模板失败');
      });
    },
    // 查看详情
    openDetail: function () {
      var _openDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return unionMemberDetail(row.id);
            case 1:
              response = _context2.v;
              this.detailDialog.data = response.data || response || {};
              this.detailDialog.visible = true;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('获取会员详情失败:', _t2);
              this.$message.error('获取会员详情失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function openDetail(_x) {
        return _openDetail.apply(this, arguments);
      }
      return openDetail;
    }(),
    openEdit: function openEdit(row) {
      this.editDialog.isCreate = !row;
      var base = row ? _objectSpread({}, row) : {
        sex: 0
      };
      this.editDialog.form = _objectSpread(_objectSpread({}, base), {}, {
        union_id: this.unionId
      });
      this.editDialog.visible = true;
    },
    closeEdit: function closeEdit() {
      var _this6 = this;
      this.editDialog.visible = false;
      this.$nextTick(function () {
        return _this6.editDialog.form = {};
      });
    },
    submitEdit: function () {
      var _submitEdit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var valid, data, errorMessage, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return this.$refs.editForm.validate();
            case 1:
              valid = _context3.v;
              if (valid) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              this.editDialog.loading = true;
              data = _objectSpread({}, this.editDialog.form);
              if (!this.editDialog.isCreate) {
                _context3.n = 4;
                break;
              }
              _context3.n = 3;
              return unionMemberCreate(data);
            case 3:
              this.$message.success('新增成功');
              _context3.n = 6;
              break;
            case 4:
              _context3.n = 5;
              return unionMemberUpdate(data);
            case 5:
              this.$message.success('修改成功');
            case 6:
              this.closeEdit();
              this.fetchList();
              this.fetchStatistics();
              _context3.n = 8;
              break;
            case 7:
              _context3.p = 7;
              _t3 = _context3.v;
              console.error('操作失败:', _t3);
              errorMessage = _t3.response && _t3.response.data && _t3.response.data.message || _t3.message || '操作失败，请重试';
              this.$message.error(errorMessage);
            case 8:
              _context3.p = 8;
              this.editDialog.loading = false;
              return _context3.f(8);
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 7, 8, 9]]);
      }));
      function submitEdit() {
        return _submitEdit.apply(this, arguments);
      }
      return submitEdit;
    }(),
    doDelete: function doDelete(row) {
      var _this7 = this;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u4F1A\u5458\"".concat(row.account || row.name || row.id, "\"\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        console.log('删除会员ID:', row.id);
        unionMemberDelete(row.id).then(function (response) {
          console.log('删除成功');
          _this7.$message.success('删除成功');
          _this7.fetchList();
          _this7.fetchStatistics();
        }).catch(function (error) {
          var _error$response2, _error$response2$data;
          console.error('删除失败:', error);
          _this7.$message.error('删除失败: ' + (((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message) || error.message || '未知错误'));
        });
      }).catch(function () {
        console.log('取消删除');
      });
    },
    pickAvatar: function pickAvatar() {
      var _this8 = this;
      this.$modalUpload(function (imgs) {
        if (imgs && imgs.length) _this8.$set(_this8.editDialog.form, 'avatar', imgs[0].sattDir || imgs[0].attDir || imgs[0].url);
      }, '1', 'unionMember');
    },
    beforeImport: function beforeImport(file) {
      var _this9 = this;
      var formData = new FormData();
      formData.append('file', file);
      if (this.unionId) formData.append('unionId', this.unionId);
      return unionMemberImport(formData).then(function () {
        _this9.$message.success('导入成功');
        _this9.importVisible = false;
        _this9.fetchList();
        _this9.fetchStatistics();
      });
    },
    exportList: function exportList() {
      var _this0 = this;
      var params = _objectSpread(_objectSpread({}, this.query), {}, {
        unionId: this.unionId
      });
      if (params.dateRange && params.dateRange.length === 2) {
        params.beginDate = params.dateRange[0];
        params.endDate = params.dateRange[1];
      }
      delete params.dateRange;
      unionMemberExport(params).then(function (response) {
        if (response.data && response.data.fileName) {
          // 直接使用后端返回的文件URL进行下载
          var link = document.createElement('a');
          link.href = response.data.fileName;
          link.download = "\u5DE5\u4F1A\u4F1A\u5458_".concat(_this0.unionName || '', ".xlsx");
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          _this0.$message.success('导出成功');
        } else {
          _this0.$message.error('获取导出文件链接失败');
        }
      }).catch(function (error) {
        console.error('导出失败:', error);
        _this0.$message.error('导出失败');
      });
    },
    // 处理同步操作
    handleSyncAction: function handleSyncAction(command) {
      switch (command) {
        case 'fullSync':
          this.handleFullSync();
          break;
        case 'syncUnionBase':
          this.handleSyncUnionBase();
          break;
        case 'syncUnionUser':
          this.handleSyncUnionUser();
          break;
        case 'goToSyncPage':
          this.goToSyncPage();
          break;
      }
    },
    // 全量同步
    handleFullSync: function () {
      var _handleFullSync = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this1 = this;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.$confirm('确认执行全量同步？这将同步所有工会信息和会员数据。', '同步确认', {
                type: 'warning',
                confirmButtonText: '确认同步',
                cancelButtonText: '取消'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var result, _t4;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.p = _context4.n) {
                    case 0:
                      _this1.syncLoading = true;
                      _context4.p = 1;
                      _context4.n = 2;
                      return fullSync();
                    case 2:
                      result = _context4.v;
                      _this1.$message.success(result.msg || '全量同步任务已启动，请查看日志了解执行结果');
                      // 同步完成后刷新统计数据和列表
                      setTimeout(function () {
                        _this1.fetchStatistics();
                        _this1.fetchList();
                      }, 2000);
                      _context4.n = 4;
                      break;
                    case 3:
                      _context4.p = 3;
                      _t4 = _context4.v;
                      _this1.$message.error('全量同步失败：' + _t4.message);
                    case 4:
                      _context4.p = 4;
                      _this1.syncLoading = false;
                      return _context4.f(4);
                    case 5:
                      return _context4.a(2);
                  }
                }, _callee4, null, [[1, 3, 4, 5]]);
              }))).catch(function () {
                _this1.$message.info('已取消同步操作');
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function handleFullSync() {
        return _handleFullSync.apply(this, arguments);
      }
      return handleFullSync;
    }(),
    // 同步工会基本信息
    handleSyncUnionBase: function () {
      var _handleSyncUnionBase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this10 = this;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.$confirm('确认同步工会基本信息？', '同步确认', {
                type: 'info',
                confirmButtonText: '确认同步',
                cancelButtonText: '取消'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
                var result, _t5;
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.p = _context6.n) {
                    case 0:
                      _this10.syncLoading = true;
                      _context6.p = 1;
                      _context6.n = 2;
                      return syncUnionBase();
                    case 2:
                      result = _context6.v;
                      _this10.$message.success(result.msg || '工会基本信息同步任务已启动');
                      _context6.n = 4;
                      break;
                    case 3:
                      _context6.p = 3;
                      _t5 = _context6.v;
                      _this10.$message.error('工会基本信息同步失败：' + _t5.message);
                    case 4:
                      _context6.p = 4;
                      _this10.syncLoading = false;
                      return _context6.f(4);
                    case 5:
                      return _context6.a(2);
                  }
                }, _callee6, null, [[1, 3, 4, 5]]);
              }))).catch(function () {
                _this10.$message.info('已取消同步操作');
              });
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function handleSyncUnionBase() {
        return _handleSyncUnionBase.apply(this, arguments);
      }
      return handleSyncUnionBase;
    }(),
    // 同步工会用户数据
    handleSyncUnionUser: function () {
      var _handleSyncUnionUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _this11 = this;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              this.$confirm('确认同步工会用户数据？', '同步确认', {
                type: 'info',
                confirmButtonText: '确认同步',
                cancelButtonText: '取消'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
                var result, _t6;
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.p = _context8.n) {
                    case 0:
                      _this11.syncLoading = true;
                      _context8.p = 1;
                      _context8.n = 2;
                      return syncUnionUser();
                    case 2:
                      result = _context8.v;
                      _this11.$message.success(result.msg || '工会用户数据同步任务已启动');
                      // 同步完成后刷新统计数据和列表
                      setTimeout(function () {
                        _this11.fetchStatistics();
                        _this11.fetchList();
                      }, 1500);
                      _context8.n = 4;
                      break;
                    case 3:
                      _context8.p = 3;
                      _t6 = _context8.v;
                      _this11.$message.error('工会用户数据同步失败：' + _t6.message);
                    case 4:
                      _context8.p = 4;
                      _this11.syncLoading = false;
                      return _context8.f(4);
                    case 5:
                      return _context8.a(2);
                  }
                }, _callee8, null, [[1, 3, 4, 5]]);
              }))).catch(function () {
                _this11.$message.info('已取消同步操作');
              });
            case 1:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function handleSyncUnionUser() {
        return _handleSyncUnionUser.apply(this, arguments);
      }
      return handleSyncUnionUser;
    }(),
    // 跳转到高级同步设置页面
    goToSyncPage: function goToSyncPage() {
      this.$router.push({
        name: 'unionSync'
      });
    },
    // 关闭详情对话框
    closeDetail: function closeDetail() {
      var _this12 = this;
      this.detailDialog.visible = false;
      this.$nextTick(function () {
        _this12.detailDialog.data = {};
      });
    },
    // 快捷键支持
    addKeyboardShortcuts: function addKeyboardShortcuts() {
      document.addEventListener('keydown', this.handleKeyDown);
    },
    removeKeyboardShortcuts: function removeKeyboardShortcuts() {
      document.removeEventListener('keydown', this.handleKeyDown);
    },
    handleKeyDown: function handleKeyDown(event) {
      // Ctrl/Cmd + N: 新增会员
      if ((event.ctrlKey || event.metaKey) && event.key === 'n') {
        event.preventDefault();
        if (this.checkPermi(['admin:union:member:create'])) {
          this.openEdit();
        }
      }

      // Ctrl/Cmd + F: 聚焦搜索框
      if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
        event.preventDefault();
        var searchInput = document.querySelector('.filter-form .el-input__inner');
        if (searchInput) {
          searchInput.focus();
        }
      }

      // ESC: 关闭所有对话框
      if (event.key === 'Escape') {
        this.editDialog.visible = false;
        this.detailDialog.visible = false;
        this.columnVisible = false;
        this.importVisible = false;
      }
    },
    // 刷新数据
    refreshData: function refreshData() {
      this.fetchList();
      this.fetchStatistics();
      this.$message.success('数据已刷新');
    },
    // 重置所有筛选条件
    resetAllFilters: function resetAllFilters() {
      this.resetSearch();
      this.selectedRows = [];
      this.$message.info('已重置所有筛选条件');
    }
  }
};